import Image from 'next/image';
import classes from './IconTitleList.module.scss';

const IconTitleList = ({ data }) => {
    let List = data?.BenefitList;
    return (
        <div className={classes.mIconList}>
            {List.map((item) => (
                <div key={item.id} className={classes.mListItem}>
                    <figure className={classes.mImage}>
                        <Image
                            src={item.image?.url}
                            width={item.image?.width}
                            height={item.image?.height}
                            alt={item.image?.title}
                            layout="fixed"
                            id={item.image?.title}
                            className={classes.aImage}
                        />
                    </figure>
                    <h4 className={`${classes.aTitle} fntH4`}>{item.title}</h4>
                </div>
            ))}
        </div>
    );
};

export default IconTitleList;
